<template>
    <div class="register-step1-2 register-section">
        <Form class="pop-common-form" :form="registerForm" @submit="handleSubmit">
            <FormItem class="form-item" label="手机号" :colon="false" v-bind="formItemLayoutCenter">
                <span class="form-item-value">{{regInfo.phone}}</span>
                <div class="form-help"><img src="../../../../assets/images/icon-notice.png">手机号可用于登录</div>
            </FormItem>
            <PhoneSMS :isSendCode.sync="isSendCode" :phone="regInfo.phone" @resetCode="getNewCode" type="2" serviceType="REG"/>
            <FormItem v-bind="tailFormItemLayout">
                <Button type="primary" html-type="submit" :disabled="isDisable">确认</Button>
                <Button class="noraml-bt" @click="goback">返回修改验证手机号</Button>
            </FormItem>
        </Form>
    </div> 
</template>
<script>
import { mapState, mapMutations } from 'vuex'
import { Form, Input, Button } from 'ant-design-vue'
import { Base64 } from 'js-base64'
import PhoneSMS from '@components/sendsms/sendmobile/index'
import FormUtil from '@utils/form'
import CONSTANT from '@utils/constant'
import FormMix from '../../formMixins'

export default {
    data() {
        return {
            // form: this.$form.createForm(this),
            isSendCode: false,
            form: {}
        }
    },
    mixins: [FormUtil, FormMix],
    methods: {
        ...mapMutations('register', ['setStepId', 'setRegInfo']),
        handleSubmit(e) {
            e.preventDefault();
            this.registerForm.validateFields((error, values) => {
                if (!error) {
                    this.checkPhoneCode()
                }
                return;
            });
        },
        async checkPhoneCode() {
            const json = await this.$store.dispatch('checkPicCode', {
                identity: this.regInfo.phone,
                appCode: CONSTANT.APPCODE_PHONE,
                appServiceCode: CONSTANT.APPSERVICECODE_REG,
                verifyCode: this.registerForm.getFieldValue('code')
            })
            if (json.code * 1 === 1) {
                this.setRegInfo({phone: this.regInfo.phone})
                this.setStepId(3)
            } else {
                this.$message.error(json.msg || '系统异常');
            }
        },
        getNewCode() {
            this.isSendCode = true
        },
        goback() {
            this.setStepId(1)
        }
    },
    computed: {
        ...mapState('register', {
            regInfo: state => state.regInfo,
        }),
    },
    components: {
        Form,
        FormItem: Form.Item,
        Input,
        Button,
        PhoneSMS
    }
}
</script>

<style lang="scss">
.register-step1-2{
    .ant-form-item-children{
        display: flex;
    }
    input {
        width: 160px;
        height: 38px;
    }
    .ant-btn-primary{
        width: 82px;
    }
}
</style>